// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"21e84407","183":"7379ee0a","239":"029b2ecd","253":"99b1d77e","453":"fc396963","898":"e13a1f6d","938":"68a56ffc","940":"d93c04ba"}[chunkId] + ".chunk.js";
};